import { BaseClaraForPlannersEventTracking } from '@/modules/ai/models/segmentevents/BaseClaraForPlannersEventTracking';
import { SegmentEvent } from '/@/integrations/segment/SegmentEvent';

export class ClaraForPlannersChatOpenedEventTracking extends BaseClaraForPlannersEventTracking {
  static eventName: string = SegmentEvent.CLARA_CHAT_OPENED;
}
